// src/pages/Parametros/tabs/TabTempo.jsx
import React from 'react';
import {
    Box, TextField, Switch, FormControlLabel,
    Typography, Paper, InputAdornment,
} from '@mui/material';
import { useParametrosAnalise } from '../../../context/ParametrosAnaliseContext';

export default function TabTempo() {
    const { params, updateGroup } = useParametrosAnalise();
    const t = params.tempo;
    const set = (field, value) => updateGroup('tempo', { [field]: value });

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 3 }}>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Tempo de execução
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                    <TextField
                        label="Tempo mínimo de execução"
                        type="number"
                        value={t.tempoMinimoExecucao}
                        onChange={(e) => set('tempoMinimoExecucao', Number(e.target.value))}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">h</InputAdornment>,
                        }}
                        inputProps={{ min: 1 }}
                        sx={{ width: 240 }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={t.bloqueioAntesDoMinimo}
                                onChange={(e) => set('bloqueioAntesDoMinimo', e.target.checked)}
                            />
                        }
                        label="Bloquear análise antes do tempo mínimo"
                    />
                </Box>
            </Paper>
            <Paper variant="outlined" sx={{ p: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} mb={2}>
                    Mensagem padrão
                </Typography>
                <TextField
                    label='Mensagem "dados insuficientes"'
                    value={t.mensagemDadosInsuficientes}
                    onChange={(e) => set('mensagemDadosInsuficientes', e.target.value)}
                    fullWidth
                    multiline
                    rows={2}
                />
            </Paper>
        </Box>
    );
}
